module.exports = __webpack_public_path__ + "img/ic-time-grey.17502fc3.svg";